import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataManagementDashboardComponent } from './components/dashboard/dashboard.component';
import { GlobalDataManagementRoutingModule } from './global-data-management-routing.module';
import { GlobalDataManagementComponent } from './global-data-management.component';
import { FormsModule } from '@angular/forms';
import { AtomicModule } from '../shared/atomic/atomic.module';
import { AngularFireFunctionsModule } from '@angular/fire/compat/functions';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { ImpersonateComponent } from './components/impersonate/impersonate.component';

@NgModule({
	declarations: [
		DataManagementDashboardComponent,
		GlobalDataManagementComponent,
		ImpersonateComponent,
	],
	imports: [
		CommonModule,
		GlobalDataManagementRoutingModule,
		FormsModule,
		AtomicModule,
		AngularFireFunctionsModule,
		AngularFireAuthModule,
	],
	providers: [],
})
export class GlodalDataManagementModule {}
